import React from 'react';
import {Controller} from "react-hook-form";
import {timeOfDay} from "../../utils/DataList";
import {CheckBox, CheckBoxOutlineBlank} from "@mui/icons-material";
import {Autocomplete, Box, Checkbox, Chip, TextField} from "@mui/material";

const icon = <CheckBoxOutlineBlank fontSize="small"/>;
const checkedIcon = <CheckBox fontSize="small"/>;

function TimeOfDayMultiSelect({control, inputLabel = "Select time of day", inputName = "values", updateOnChange = () => null}) {
    return (
        <Controller
            render={({field: {onChange, ...props}}) => (
                <Autocomplete
                    multiple
                    disableCloseOnSelect={true}
                    id="multi-time-of-day-select"
                    isOptionEqualToValue={(option, value) => option.label === value.label}
                    getOptionLabel={(option) => option.label}
                    options={timeOfDay}
                    renderOption={(props, option, {selected, index}) => (
                        <li {...props} key={index}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                sx={{mr: 1}}
                                checked={selected}
                                color="primary"
                            />
                            {option.label}
                        </li>
                    )}
                    renderValue={(selected, getTagProps) =>
                        selected?.map((option, index) => {
                            const { key, ...tagProps } = getTagProps({ index });
                            return (
                                <Chip
                                    key={key}
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    label={option?.label}
                                    {...tagProps}
                                />
                            );
                        })
                    }
                    renderInput={params => (
                        <Box display="flex">
                            <Box flexGrow={1}>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    label={inputLabel}
                                />
                            </Box>
                        </Box>
                    )}
                    onChange={(e, data) => {
                        onChange(data);
                        updateOnChange();
                    }}
                    {...props}
                />
            )}
            defaultValue={[]}
            name={inputName}
            control={control}
            onChange={([, data]) => data}
        />
    );
}

export default TimeOfDayMultiSelect;